import script from "./TenantBottomNav.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantBottomNav.vue?vue&type=script&setup=true&lang=js"

import "./TenantBottomNav.vue?vue&type=style&index=0&id=34a55cfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34a55cfa"]])

export default __exports__